export class ui_logs_query_request {
    public take: number = 1000;

    public fromUtc: string | null = null;
    public toUtc: string | null = null;

    // null => sin filtrar (equivalente a "Todos")
    public level: string | null = null;

    // texto libre (mensaje, excepción, trace_id, etc.)
    public contains: string | null = null;

    constructor(src?: any) {
        if (src) {
            Object.assign(this, src);
        }
    }
}
